import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import DataTable from '../DataTable';
import { observable, action } from 'mobx';

@inject('roleStore')
@observer
class RolePermissionList extends Component {
  static propTypes = {
    params: PropTypes.shape().isRequired,
    route: PropTypes.shape().isRequired,
    children: PropTypes.node,
  }

  @observable items = [];

  constructor(props) {
    super(props);

    this.handleDelete = this.handleDelete.bind(this);
  }

  componentWillMount() {
    const { roleStore, params: { id } } = this.props;
    this.reset();
  }

  @action reset() {
    const { roleStore, params: { id } } = this.props;
    roleStore.fetchPermissions(id)
      .then((permissions) => {
        console.log('permissions', permissions);
        this.items = permissions;
      })
      .catch(err => {
        console.log('err', err);
      });
  }

  handleDelete(idOrIds) {
    console.log('handleDelete', idOrIds);
    this.props.roleStore.removeItems(idOrIds);
  }

  slug = '/role';
  columns = [
    { key: 'id', label: 'ID' },
    { key: 'name', label: 'Name' },
    { key: 'description', label: 'Description' },
  ];

  render() {
    const { roleStore } = this.props;
    // const { route: { roleStore }, children } = this.props;
    const { children } = this.props;
    return (
      <div>
      RolePermissionList
      <table>
        {this.items.map(item => {
          return (
            <tbody key={item.permission}>
              <tr>
                <td>
                  <em>{item.resource}: </em> {item.permission}
                </td>
                <td>{item.role_id}</td>
              </tr>
            </tbody>
          );
        })}
      </table>
      </div>
    );

    // return (
    //   <div>
    //     <DataTable
    //       data={roleStore.items}
    //       slug={this.slug}
    //       columns={this.columns}
    //       onDelete={this.handleDelete}
    //       allowAdd
    //       allowEdit
    //       allowDelete
    //       resource='role'
    //     />
    //     {children}
    //   </div>
    // );
  }
}

export default RolePermissionList;



// WEBPACK FOOTER //
// ./src/components/Role/RolePermissionList.js